import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FlaskConical, CheckCircle2, XCircle } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

// Stands in for the PROVIDER-HOSTED bank onboarding page while PEEPING PAY is in sandbox.
// PEEPING never sees bank credentials; it only receives a signed account.updated webhook.
export default function SandboxConnect() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [a, setA] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/pay/sandbox/connect/${id}`).then((r) => setA(r.data.account)).catch(() => setError("Payout account not found."));
  }, [id]);
  const back = () => navigate(a?.owner_type === "platform" ? "/admin/finance" : "/creator/billing", { replace: true });
  const simulate = async (outcome) => {
    setBusy(true);
    try {
      await api.post(`/pay/sandbox/connect/${id}/simulate`, { outcome });
      back();
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail));
      setBusy(false);
    }
  };
  return (
    <div data-testid="sandbox-connect-screen" className="min-h-screen bg-[#f4f2f7] px-5 py-10 text-[#15121b]">
      <div className="mx-auto max-w-sm">
        <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#6a00ff]"><FlaskConical size={14} /> Sandbox payout provider</p>
        <h1 className="mt-2 text-2xl font-extrabold">Connect a bank account</h1>
        <p className="mt-1 text-xs text-[#5c5566]">This page represents the processor's hosted onboarding. Bank details are entered with the provider only — PEEPING never stores them. No real account is linked in sandbox.</p>
        {a && (
          <div className="mt-6 flex flex-col gap-2 rounded-2xl border border-black/10 bg-white p-5 shadow-sm">
            <p className="text-sm text-[#5c5566]">{a.owner_type === "platform" ? "PEEPING platform account" : "Creator payout account"} · {a.status}</p>
            <button disabled={busy} onClick={() => simulate("verified")} data-testid="sandbox-connect-verify" className="flex items-center justify-center gap-2 rounded-xl bg-[#15121b] py-3 text-sm font-semibold text-white"><CheckCircle2 size={16} /> Simulate verified bank</button>
            <button disabled={busy} onClick={() => simulate("restricted")} data-testid="sandbox-connect-restrict" className="flex items-center justify-center gap-2 rounded-xl border border-black/15 py-3 text-sm font-semibold"><XCircle size={16} /> Simulate verification failure</button>
          </div>
        )}
        {error && <p data-testid="sandbox-connect-error" className="mt-4 text-sm text-red-600">{error}</p>}
        <button onClick={back} className="mt-6 text-xs text-[#5c5566] underline">Cancel and return to PEEPING</button>
      </div>
    </div>
  );
}
